/* Royal Hair – mandatory purchase consent in the cart.
   Products are added to the cart normally. The consent shows in the cart directly
   above the checkout button, based on the products in the cart:
   extensions -> extensions consent, wigs/toppers/clip-on -> hair-product consent, both -> both.
   Checkout (button, cart popup, accelerated checkout, salon deposit) stays blocked until
   every required consent is ticked. Acceptance is saved as cart attributes
   (text, version, link, timestamp) and is carried to the order. */
(function () {
  if (window.RHConsent) return;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var TYPES = ['ext', 'hair'];
  var pending = null;

  function box() { return document.querySelector('[data-rh-cart-consent]'); }
  function group(type) { var b = box(); return b ? b.querySelector('[data-rh-cc="' + type + '"]') : null; }
  function input(g) { return g && g.querySelector('[data-rh-cc-input]'); }
  function required() {
    return TYPES.map(group).filter(function (g) { return g && !g.hidden; });
  }
  function okLocal() {
    return required().every(function (g) { var i = input(g); return i && i.checked; });
  }

  function attrsFor(g, on) {
    var k = g.dataset.key, a = {};
    a[k] = on ? g.dataset.value : '';
    a[k + ' – tekst'] = on ? g.dataset.text : '';
    a[k + ' – versjon'] = on ? g.dataset.version : '';
    a[k + ' – lenke'] = on ? g.dataset.link : '';
    a[k + ' – tidspunkt'] = on ? new Date().toISOString() : '';
    return a;
  }
  function save(attrs) {
    var p = fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-RH-Consent': '1' },
      body: JSON.stringify({ attributes: attrs })
    }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
    pending = p;
    var done = function () { if (pending === p) pending = null; express(); };
    p.then(done, done);
    express();
    return p;
  }

  function fetchState() {
    return fetch(ROOT + 'cart?view=rh-consent', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (t) {
        var s = JSON.parse(t);
        if (!s || !s.ext || !s.hair) throw new Error('Unexpected consent state');
        return s;
      });
  }
  function stateOk(s) {
    return TYPES.every(function (k) { return !s[k] || !s[k].required || s[k].accepted; });
  }

  function showError(g) {
    g.classList.add('is-invalid');
    var e = g.querySelector('[data-rh-cc-error]');
    if (e) e.hidden = false;
    var i = input(g);
    if (i) i.setAttribute('aria-invalid', 'true');
  }
  function clearError(g) {
    g.classList.remove('is-invalid');
    var e = g.querySelector('[data-rh-cc-error]');
    if (e) e.hidden = true;
    var i = input(g);
    if (i) i.removeAttribute('aria-invalid');
  }
  function showErrors() {
    var first = null;
    required().forEach(function (g) {
      var i = input(g);
      if (i && !i.checked) { showError(g); if (!first) first = g; }
    });
    if (first) {
      first.scrollIntoView({ behavior: 'smooth', block: 'center' });
      try { input(first).focus({ preventScroll: true }); } catch (err) { input(first).focus(); }
    }
  }

  /* Accelerated checkout in the cart (Shop Pay, Apple Pay, Vipps, PayPal …) is only
     shown once every required consent is ticked and saved to the cart. */
  function express() {
    var b = box();
    if (!b) return;
    var lock = required().length > 0 && (!okLocal() || !!pending);
    document.querySelectorAll('.cart__dynamic-checkout-buttons, .additional-checkout-buttons').forEach(function (w) {
      w.classList.toggle('rh-consent-pay--hidden', lock);
      w.inert = lock;
      if (lock) w.setAttribute('aria-hidden', 'true'); else w.removeAttribute('aria-hidden');
    });
  }

  /* Re-read the cart after quantity changes / removals and show the right consent. */
  var refreshTimer = null;
  function refresh() {
    var b = box();
    if (!b) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetchState().then(function (s) {
        var clear = {};
        TYPES.forEach(function (k) {
          var g = group(k);
          if (!g || !s[k]) return;
          g.hidden = !s[k].required;
          var i = input(g);
          if (s[k].required) {
            if (i && !pending) i.checked = !!s[k].accepted;
          } else {
            if (i) i.checked = false;
            clearError(g);
            if (s[k].present) Object.assign(clear, attrsFor(g, false));
          }
        });
        b.hidden = required().length === 0;
        if (Object.keys(clear).length) save(clear);
        express();
      }).catch(function () { express(); });
    }, 400);
  }

  function proceed(el) {
    var f = el && (el.form || (el.closest && el.closest('form')));
    if (f) {
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'checkout'; h.value = '';
      f.appendChild(h);
      HTMLFormElement.prototype.submit.call(f);
    } else {
      window.location.href = ROOT + 'checkout';
    }
  }

  /* Go to checkout only when the cart's consent is in place; otherwise open the cart. */
  function toCheckout() {
    return fetchState()
      .then(function (s) { window.location.href = ROOT + (stateOk(s) ? 'checkout' : 'cart'); })
      .catch(function () { window.location.href = ROOT + 'cart'; });
  }

  function guard(e, el) {
    if (box()) {
      if (!okLocal()) {
        e.preventDefault(); e.stopImmediatePropagation();
        showErrors();
        return;
      }
      if (pending) {
        e.preventDefault(); e.stopImmediatePropagation();
        pending.then(function () { proceed(el); }, function () { showErrors(); });
      }
      return;
    }
    // Outside the cart page (cart popup, cart drawer): check the cart before leaving.
    e.preventDefault(); e.stopImmediatePropagation();
    fetchState().then(function (s) {
      if (stateOk(s)) proceed(el); else window.location.href = ROOT + 'cart';
    }).catch(function () { window.location.href = ROOT + 'cart'; });
  }

  function isCheckoutEl(t) {
    if (!t || !t.closest) return null;
    var el = t.closest('button[name="checkout"], input[name="checkout"], #checkout, a[href$="/checkout"], a[href*="/checkout?"]');
    return el;
  }

  document.addEventListener('click', function (e) {
    var el = isCheckoutEl(e.target);
    if (el) guard(e, el);
  }, true);

  document.addEventListener('submit', function (e) {
    var sub = e.submitter;
    var f = e.target;
    var toCheckoutForm = (sub && sub.name === 'checkout') || (f && f.getAttribute && /\/checkout(\?|$)/.test(f.getAttribute('action') || ''));
    if (toCheckoutForm) guard(e, sub || f);
  }, true);

  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-rh-cc-input]')) return;
    var g = t.closest('[data-rh-cc]');
    if (!g) return;
    if (t.checked) clearError(g);
    save(attrsFor(g, t.checked)).catch(function () { t.checked = !t.checked; express(); });
  });

  function start() {
    if (!box()) return;
    express();
    refresh();
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) subscribe(PUB_SUB_EVENTS.cartUpdate, refresh);
    } catch (err) {}
    // Any cart change made by the theme (quantity, remove, add) -> re-check which consent is needed.
    if (window.fetch && !window.fetch.__rhConsent) {
      var origFetch = window.fetch;
      var wrapped = function (resource, init) {
        var url = typeof resource === 'string' ? resource : (resource && resource.url) || '';
        var mine = init && init.headers && (init.headers['X-RH-Consent'] || (init.headers.get && init.headers.get('X-RH-Consent')));
        var p = origFetch.apply(this, arguments);
        if (!mine && /\/cart\/(change|add|update|clear)(\.js)?/.test(url)) {
          p.then(function () { refresh(); }, function () {});
        }
        return p;
      };
      wrapped.__rhConsent = true;
      window.fetch = wrapped;
    }
    var items = document.querySelector('cart-items') || document.getElementById('main-cart-items');
    if (items) new MutationObserver(refresh).observe(items, { childList: true, subtree: true });
    // Accelerated checkout buttons render late.
    var footer = document.getElementById('main-cart-footer') || document.body;
    new MutationObserver(express).observe(footer, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  window.RHConsent = {
    toCheckout: toCheckout,
    refresh: refresh,
    ok: okLocal,
    props: function () { return {}; }
  };
})();
